import { Namespace, TFunction } from 'react-i18next';
import * as Yup from 'yup';

import { IFormValues } from '../interfaces';

const MIN_PASSWORD_LENGTH = 8;

const password = (t: TFunction<Namespace<'validation'>>) =>
  Yup.string()
    .required(t('required'))
    .test(
      'len',
      t('passwordMinLength', { length: MIN_PASSWORD_LENGTH }),
      (val) => (val?.length || 0) >= MIN_PASSWORD_LENGTH
    )
    .matches(/^[^а-яёА-ЯЁ]+$/, t('passwordLetters'));

export const ValidationSchema = (t: TFunction<Namespace<'validation'>>): Yup.SchemaOf<IFormValues> =>
  Yup.object().shape({
    scope_title: Yup.string().trim().required(t('required')),
    first_name: Yup.string().trim().required(t('required')),
    last_name: Yup.string().trim().required(t('required')),
    phone: Yup.string().required(t('required')),
    title: Yup.string().trim().required(t('required')),
    password: password(t),
    second_pwd: password(t),
  });
